//格式化日期
//  时间字符串转化为标准时间格式
//  转化后格式为：xxxx-xx-xx xx:xx:xx
export function changeTime(timestamp) {
  var date = new Date(timestamp * 1000); //根据时间戳生成的时间对象
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  var second = date.getSeconds();
  second = second < 10 ? "0" + second : second;
  return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
}

//  时间字符串转化为标准时间格式
//  转化后格式为：xxxx年xx月xx日
export function changeTime2(timestamp) {
  var date = new Date(timestamp * 1000); //根据时间戳生成的时间对象
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  return y + "年" + m + "月" + d + "日";
}

export function getQueryValue(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
